<template>
  <div v-if="open" class="overlay">
    <div class="modal">
      <div class="modal-glow"></div>

      <div class="modal-head">
        <div>
          <div class="eyebrow">Actualización disponible</div>
          <h3>Hay una versión nueva de Notas</h3>
        </div>
        <div class="badge">{{ remaining }}s</div>
      </div>

      <p class="copy">
        Encontramos una versión más reciente y vamos a recargar para aplicarla.
        Puedes hacerlo ahora o esperar a que termine la cuenta regresiva.
      </p>

      <div class="note-strip" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div class="progress-wrap" aria-label="Actualizando aplicación">
        <div class="progress-bar" :style="{ width: `${progress}%` }"></div>
      </div>

      <div class="actions">
        <button class="primary-btn" type="button" @click="$emit('refresh')" :disabled="updating">
          {{ updating ? 'Actualizando…' : 'Recargar ahora' }}
        </button>
      </div>

      <p class="hint">
        {{ sourceLabel }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateReloadModal',
  props: {
    open: { type: Boolean, default: false },
    remaining: { type: Number, default: 10 },
    progress: { type: Number, default: 0 },
    updating: { type: Boolean, default: false },
    source: { type: String, default: '' },
  },
  emits: ['refresh'],
  computed: {
    sourceLabel() {
      if (this.source === 'service-worker') {
        return 'La app ya descargó la nueva versión y solo falta activarla.';
      }
      return 'La app detectó una publicación más nueva y recargará para traerla.';
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  z-index: 120;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.38);
  backdrop-filter: blur(8px);
}
.modal {
  position: relative;
  width: min(560px, 100%);
  overflow: hidden;
  border-radius: 30px;
  border: 1px solid rgba(148, 163, 184, 0.24);
  background:
    linear-gradient(180deg, rgba(255,255,255,0.98), rgba(248,250,252,0.96)),
    repeating-linear-gradient(
      180deg,
      rgba(59,130,246,0.02) 0,
      rgba(59,130,246,0.02) 1px,
      transparent 1px,
      transparent 34px
    );
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.22);
  padding: 24px;
}
.modal-glow {
  position: absolute;
  inset: auto auto -40px -50px;
  width: 170px;
  height: 170px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(59,130,246,0.16), transparent 70%);
  pointer-events: none;
}
.modal-head {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}
.eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748b;
}
h3 {
  margin: 6px 0 0;
  font-size: 30px;
  line-height: 1.1;
  color: #0f172a;
}
.badge {
  flex: none;
  padding: 10px 14px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.08);
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
}
.copy {
  position: relative;
  margin: 14px 0 0;
  color: #475569;
  line-height: 1.6;
  font-size: 15px;
}
.note-strip {
  position: relative;
  display: flex;
  gap: 8px;
  margin: 18px 0 16px;
}
.note-strip span {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: rgba(59, 130, 246, 0.22);
  box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.12);
}
.progress-wrap {
  position: relative;
  height: 12px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.18);
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.08);
}
.progress-bar {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #111827, #2563eb 68%, #60a5fa);
  transition: width 0.12s linear;
}
.actions {
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}
.primary-btn {
  border: none;
  border-radius: 16px;
  padding: 13px 18px;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.18s ease, opacity 0.18s ease, box-shadow 0.18s ease;
  background: #111827;
  color: #fff;
  box-shadow: 0 12px 28px rgba(17, 24, 39, 0.18);
}
.primary-btn:hover {
  transform: translateY(-1px);
}
.primary-btn:disabled {
  opacity: 0.7;
  cursor: default;
  transform: none;
}
.hint {
  position: relative;
  margin: 14px 0 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
}
@media (max-width: 640px) {
  .modal {
    padding: 20px;
    border-radius: 24px;
  }
  .modal-head {
    flex-direction: column;
  }
  h3 {
    font-size: 24px;
  }
  .badge {
    align-self: flex-start;
  }
  .primary-btn {
    width: 100%;
  }
}
</style>
